import { render, staticRenderFns } from "./TagsGroup.vue?vue&type=template&id=f005a712&scoped=true"
import script from "./TagsGroup.vue?vue&type=script&lang=js"
export * from "./TagsGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f005a712",
  null
  
)

export default component.exports